import configs from "./configs";
import settings from "./settings";
export default {
    configs, settings
};
